var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "cont-tit" }, [
      _c("div", { staticClass: "tbl-top-etc" }, [
        _vm._v(_vm._s(/*(연이율, 세전, 단위 : %)*/ _vm.$t("MDEP-01-02-01-08")))
      ])
    ]),
    _c("table", { staticClass: "table -type03" }, [
      _c("thead", [
        _c("tr", [
          _c("th", { attrs: { scope: "col" } }, [
            _vm._v(_vm._s(/*기간*/ _vm.$t("MDEP-01-02-02-06")))
          ]),
          _c("th", { attrs: { scope: "col" } }, [_vm._v("USD")]),
          _c("th", { attrs: { scope: "col" } }, [_vm._v("KHR")]),
          _c("th", [_vm._v(_vm._s(/*금리구분*/ _vm.$t("MDEP-01-02-02-08")))])
        ])
      ]),
      _c("tbody", [
        _c("tr", [
          _c("td", {
            domProps: {
              innerHTML: _vm._s(
                /*6개월 이상~12개월 미만*/ _vm.$t("MDEP-01-02-02-17")
              )
            }
          }),
          _c("td", [_vm._v("3.05")]),
          _c("td", { attrs: { rowspan: "4" } }, [_vm._v("N/A")]),
          _c("td", [_vm._v(_vm._s(/*확정금리*/ _vm.$t("MDEP-01-02-02-09")))])
        ]),
        _c("tr", [
          _c("td", {
            domProps: {
              innerHTML: _vm._s(
                /*1년 이상~2년 미만*/ _vm.$t("MDEP-01-02-02-18")
              )
            }
          }),
          _c("td", [_vm._v("3.50")]),
          _c("td", [_vm._v(_vm._s(/*확정금리*/ _vm.$t("MDEP-01-02-02-09")))])
        ]),
        _c("tr", [
          _c("td", {
            domProps: {
              innerHTML: _vm._s(
                /*2년 이상~3년 미만*/ _vm.$t("MDEP-01-02-02-19")
              )
            }
          }),
          _c("td", [_vm._v("3.70")]),
          _c("td", [_vm._v(_vm._s(/*확정금리*/ _vm.$t("MDEP-01-02-02-09")))])
        ]),
        _c("tr", [
          _c("td", {
            domProps: {
              innerHTML: _vm._s(/*3년 이상*/ _vm.$t("MDEP-01-02-02-20"))
            }
          }),
          _c("td", [_vm._v("3.85")]),
          _c("td", [_vm._v(_vm._s(/*확정금리*/ _vm.$t("MDEP-01-02-02-09")))])
        ])
      ])
    ]),
    _c("div", { staticClass: "info info-etc" }, [
      _vm._v(
        "· " +
          _vm._s(/*영업점 내점상담 후, 금리 결정*/ _vm.$t("MDEP-01-02-02-21"))
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }